module.exports = require('es6-promise').Promise;



//////////////////
// WEBPACK FOOTER
// ./~/es6-promise-promise/index.js
// module id = 3
// module chunks = 0 1